import React, { useState } from "react";
import { Link, useHistory } from "react-router-dom";
import axiosInstance, { getUserDetails } from "../../components/content/axiosConfig";
import Preloader from "../../components/custom/preLoader";
import showErrorToast,{ showSuccessToast } from "../../components/toast/toast";

const CreatePond = () => {
  const history = useHistory();
  const fisherID = getUserDetails().FisherID;
  const [isLoading, setIsLoading] = useState(false);
  const [formData, setFormData] = useState({
    Name: "",
    Location: "",
    Weight_Unit: "",
    Length_Unit: "",
    FisherID: 0,
    NoFishTypes: 0,
    NoFishes: 0
  });

  const handleChange = (e) => {
    const { id, value, type, checked, name } = e.target;
    if (type === "radio") {
      setFormData({
        ...formData,
        [name]: value === "true",
      });
    } else {
      setFormData({
        ...formData,
        [id]: type === "checkbox" ? checked : value,
      });
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    // Validation
    if (!formData.Name.trim()) {
      showErrorToast("Name is required");
      setIsLoading(false);
      return;
    }
    if (!formData.Location.trim()) {
      showErrorToast("Location is required");
      setIsLoading(false);
      return;
    }
    if (!formData.Weight_Unit) {
      showErrorToast("Weight Unit is required");
      setIsLoading(false);
      return;
    }
    if (!formData.Length_Unit) {
      showErrorToast("Length Unit is required");
      setIsLoading(false);
      return;
    }
    const noFishes = parseInt(formData.NoFishes);
    if (isNaN(noFishes) || noFishes < 0) {
      showErrorToast("Number of Fishes must be a non-negative integer");
      setIsLoading(false);
      return;
    }
    const noFishTypes = parseInt(formData.NoFishTypes);
    if (isNaN(noFishTypes) || noFishTypes < 0) {
      showErrorToast("Number of Fish Types must be a non-negative integer");
      setIsLoading(false);
      return;
    }

    setIsLoading(true);
    try {
      await axiosInstance.post("api/Pond/AddPond", {
        Name: formData.Name,
        Location: formData.Location,
        Weight_Unit: formData.Weight_Unit,
        Length_Unit: formData.Length_Unit,
        NoFishes: 0,
        NoFishTypes: 0,
        FisherID: fisherID
      });
      showSuccessToast("Pond created successfully");
      setIsLoading(false);
      history.push("/pond");
    } catch (error) {
      setIsLoading(false);
      if (error.response && error.response.status === 401) {
        localStorage.removeItem("user");
        localStorage.removeItem("token");
        window.location.reload();
      }
      const errorMessage = error.response?.data?.message || "An error occurred.";
      showErrorToast(errorMessage);
    }
  };

  return (
    isLoading ? <Preloader /> :
    <div>
      <form onSubmit={handleSubmit} className="fs-13px">
        <div className="d-flex align-items-center mb-3">
          <div>
            <ul className="breadcrumb">
              <li className="breadcrumb-item">
                <Link to="/">Home</Link>
              </li>
              <li className="breadcrumb-item">
                <Link to="/pond">Pond</Link>
              </li>
              <li className="breadcrumb-item active">Create Pond</li>
            </ul>
            <h1 className="page-header mb-0">Create Pond</h1>
          </div>
          <div className="ms-auto">
            <button
              type="submit"
              className="btn btn-success btn-rounded px-4 rounded-pill"
            >
              <i className="fa fa-plus fa-lg me-2 ms-n2 text-success-900"></i>
              Submit
            </button>
          </div>
        </div>
        <div className="card border-0">
          <div className="tab-content p-3">
            <div className="tab-pane fade show active" id="allTab">
              <div className="form-floating mb-15px">
                <input
                  type="text"
                  className="form-control h-45px fs-13px"
                  placeholder="Pond Name"
                  id="Name"
                  value={formData.Name}
                  onChange={handleChange}
                />
                <label
                  htmlFor="Name"
                  className="d-flex align-items-center fs-13px text-gray-600"
                >
                  Name
                </label>
              </div>
              <div className="form-floating mb-25px">
                <input
                  type="text"
                  className="form-control h-45px fs-13px"
                  placeholder="Location"
                  id="Location"
                  value={formData.Location}
                  onChange={handleChange}
                />
                <label
                  htmlFor="Location"
                  className="d-flex align-items-center fs-13px text-gray-600"
                >
                  Location
                </label>
              </div>
              <div className="form-floating mb-25px">
                <input
                  type="text"
                  className="form-control h-45px fs-13px"
                  placeholder="NoFishes"
                  id="NoFishes"
                  value={formData.NoFishes}
                  onChange={handleChange}
                />
                <label
                  htmlFor="NoFishes"
                  className="d-flex align-items-center fs-13px text-gray-600"
                >
                  Number of Fishes
                </label>
              </div>
              <div className="form-floating mb-25px">
                <input
                  type="text"
                  className="form-control h-45px fs-13px"
                  placeholder="NoFishTypes"
                  id="NoFishTypes"
                  value={formData.NoFishTypes}
                  onChange={handleChange}
                />
                <label
                  htmlFor="NoFishTypes"
                  className="d-flex align-items-center fs-13px text-gray-600"
                >
                  Number of Fish Types
                </label>
              </div>
              <div className="form-floating mb-25px">
                <select
                  className="form-control h-50px fs-13px"
                  id="Weight_Unit"
                  name="Weight_Unit"
                  value={formData.Weight_Unit}
                  onChange={handleChange}
                >
                  <option value="">Select Weight Unit</option>
                  <option value="Decimal Pounds">Decimal Pounds</option>
                  <option value="Grams">Grams</option>
                </select>
                <label
                  htmlFor="Weight_Unit"
                  className="d-flex align-items-center fs-13px text-gray-600"
                >
                  Weight Unit &nbsp; <span>*</span>
                </label>
              </div>
              <div className="form-floating mb-15px">
                <select
                  className="form-control h-45px fs-13px"
                  id="Length_Unit"
                  name="Length_Unit"
                  value={formData.Length_Unit}
                  onChange={handleChange}
                >
                  <option value="">Select Length Unit</option>
                  <option value="Decimal Inches">Decimal Inches</option>
                  <option value="Millimeters">Millimeters</option>
                </select>
                <label
                  htmlFor="Length_Unit"
                  className="d-flex align-items-center fs-13px text-gray-600"
                >
                  Length Unit &nbsp; <span>*</span>
                </label>
              </div>
            </div>
          </div>
        </div>
      </form>
    </div>
  );
};

export default CreatePond;